import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";

import DownloadIcon from "@mui/icons-material/DownloadOutlined";
import AppleIcon from "@mui/icons-material/Apple";
import ContentCopyIcon from "@mui/icons-material/ContentCopyOutlined";
import ShareIcon from "@mui/icons-material/ShareOutlined";
import VisibilityIcon from "@mui/icons-material/VisibilityOutlined";

const Build = (props) => {
    const {
        id,
        version,
        os,
        created_at,
        file_type,
        file_path,
        signedUrl,
        envirionment,
        is_public,
    } = props.build;
    const appId = props.app.id;
    const _organizationId = props?.organizationId;
    const role = useSelector((state) => state.userLogin.userInfo.data.role);

    const downloadBuild = () => {
        const link = document.createElement("a");
        link.href = file_path;
        link.download = `app-${version}`;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const copyItmsUrl = (e) => {
        e.preventDefault();
        navigator.clipboard
            .writeText(`itms-services://?action=download-manifest&url=${signedUrl}`)
            .then(() => toast.success("iOS install link copied"))
            .catch(() => toast.error("Failed to copy link"));
    };

    const copyShareUrl = (e) => {
        e.preventDefault();
        const shareUrl = `${window.location.origin}/install/${appId}/${id}`;
        navigator.clipboard
            .writeText(shareUrl)
            .then(() => toast.success("Public install URL copied"))
            .catch(() => toast.error("Failed to copy URL"));
    };

    const viewDetailHref =
        role === "Super_Admin"
            ? `/organization/${_organizationId}/app/${appId}/build/${id}/view`
            : `/app/${appId}/build/${id}/view`;

    return (
        <TableRow hover>
            <TableCell sx={{ fontWeight: 600 }}>{version}</TableCell>
            <TableCell sx={{ color: "text.secondary", whiteSpace: "nowrap" }}>
                {moment(created_at).format("MMM DD, YYYY, hh:mm A")}
            </TableCell>
            <TableCell>
                <Chip
                    label={os}
                    size="small"
                    variant="outlined"
                    icon={os === "iOS" ? <AppleIcon /> : undefined}
                />
            </TableCell>
            <TableCell sx={{ color: "text.secondary" }}>{file_type}</TableCell>
            <TableCell>
                <Chip
                    label={envirionment}
                    size="small"
                    color={envirionment === "Production" ? "success" : "warning"}
                    variant="outlined"
                />
            </TableCell>
            <TableCell>
                {is_public ? (
                    <Chip
                        label="Public"
                        size="small"
                        sx={{
                            bgcolor: "#DCFCE7",
                            color: "#166534",
                            fontWeight: 700,
                            letterSpacing: "0.04em",
                            textTransform: "uppercase",
                        }}
                    />
                ) : (
                    <Chip
                        label="Private"
                        size="small"
                        sx={{
                            bgcolor: "#F1F5F9",
                            color: "#475569",
                            fontWeight: 700,
                            letterSpacing: "0.04em",
                            textTransform: "uppercase",
                        }}
                    />
                )}
            </TableCell>
            <TableCell align="center">
                <Stack direction="row" spacing={0.5} justifyContent="center">
                    <IconButton onClick={downloadBuild} title="Download build" size="small">
                        <DownloadIcon fontSize="small" />
                    </IconButton>

                    {os === "iOS" && (
                        <>
                            <IconButton
                                component="a"
                                href={`itms-services://?action=download-manifest&url=${signedUrl}`}
                                title="Install build (iOS OTA)"
                                size="small"
                            >
                                <AppleIcon fontSize="small" />
                            </IconButton>
                            <IconButton onClick={copyItmsUrl} title="Copy iOS install link" size="small">
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                        </>
                    )}

                    {is_public && (
                        <IconButton
                            onClick={copyShareUrl}
                            title="Copy public install link (share with testers)"
                            size="small"
                            sx={{ color: "primary.dark" }}
                        >
                            <ShareIcon fontSize="small" />
                        </IconButton>
                    )}

                    <IconButton component={RouterLink} to={viewDetailHref} title="View build details" size="small">
                        <VisibilityIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </TableCell>
        </TableRow>
    );
};

export default Build;
